// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3E5VI","errors":"Errors_errors__2DEfd"};